const serviceColours: { [key: string]: string } = {
  Editorial: '#e2001a',
  Photography: '#e78d2d',
  Video: '#fff600',
  Plans: '#43ac6a',
  Digital: '#8c9fbf',
  'Ad Copy': '#b69deb',
  Signboards: '#d0c6b1',
  Aerial: '#404041',
  Print: '#d5e5d5',
}

export const formatServiceBreakdown = (services: { label: string, value: number }[]) => {
  const formattedServiceBreakdown: Array<{ [key: string]: number }> = []
  const formattedThemes:{ [key: string]: object } = {}

  services?.forEach((item) => {
    if (item.value > 0){
      formattedServiceBreakdown.push({ [item.label]: item.value })
      formattedThemes[item.label] = {
        title: item.label,
        colors: {
          border: 'black', primary: 'white', secondary: serviceColours[item.label],
        },
      }
    }
  })

  const data = {
    formattedServiceBreakdown, formattedThemes,
  }

  return data
}

export default formatServiceBreakdown
